export default "__VITE_ASSET__BNN2bndr__"